import styled from "styled-components";

export const LogoWrapper = styled("div")<{
  $gap: number;
  $inline: boolean;
}>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $gap }) => $gap}px;
  flex-direction: ${({ $inline }) => ($inline ? "row" : "column")};
`;

export const LogoImage = styled("img")<{
  $size: number;
  $rounded: number;
}>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ $rounded }) => $rounded}px;
  object-fit: contain;
  flex-shrink: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
`;

export const LogoName = styled("span")<{
  $size: "sm" | "md" | "lg";
}>`
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.2;

  ${({ $size }) =>
    $size === "sm" &&
    `
    font-size: 0.95rem;
  `}

  ${({ $size }) =>
    $size === "md" &&
    `
    font-size: 1.35rem;
  `}

  ${({ $size }) =>
    $size === "lg" &&
    `
    font-size: 2rem;
  `}
`;
